/* eslint-disable no-undef */
import React, { Component } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Col, Container, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import cx from "classnames";

import Host from "assets/images/tot/HostLobby.png";
import Bingo from "components/bingo";
import TotMain from "components/tot";
import CTPlayer from "components/ct";
import OCHPlayer from "components/och";
import Fluster from "components/fluster";
import SlideKick from "components/slideKick";
import Header from "components/layout/header";
import DWPlayers from "components/dw20/dwPlayers";
import TwHeader from "components/gameData/TwHeader";
import SmallBitesLobby from "components/smallBites";
import ChartyPartyLobby from "components/charty-party";
import { updateTagToHasPlayed } from "components/shared/mailchimp";
import { createNewRoom, end_Game, getGameName } from "components/shared/utils";
import {
  slideHorizontalRightExitVariants,
  slideHorizontalRightVariants
} from "components/shared/utils/animations";
import * as gameAction from "redux/game/action";
import { setIsLoading } from "redux/loader/action";
import * as loaderAction from "redux/loader/action";
import * as webUrlAction from "redux/webUrl/action";
import * as socketAction from "redux/sockets/action";
import * as paramsAction from "redux/gameParams/actions";
import Socket from "socket/socket";
import Player from "./player";
import JoinNow from "./joinNow";
import IceBreakers from "./IceBreaker";
import Teams from "../verbodenGame/teams";
import Timer from "../verbodenGame/timer";

class LobbyScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersChanged: false,
      timer: 60,
      backBtnPress: false,
      link: "",
      poped: false,
      howtoplay_modal_tot: false,
      vb_start_game: false
    };
  }
  async componentDidMount() {
    this.removeListener = Socket.addListener("others", (res) => {
      if (!_.isEmpty(res.room)) this.props.setIsLoading(false);
    });
    window.onpopstate = () => {
      end_Game(this.props.gameReducer.roomObj);
    };
    let gameObj = this.props.gameReducer;
    let dataObj = {
      gameName:
        gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
    };
    let currentuser = gameObj.currentUser;

    this.props.getGameData(dataObj);

    const cognitoUser = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    if (cognitoUser === null) {
      this.props.history.push("/signup");
    }
    if (
      this.props.history.action === "POP" &&
      this.props.history.location.pathname === "/lobby" &&
      !this.state.poped
    ) {
      await this.reset();
      this.setState({ poped: true });
      this.props.setIsLoading(false);
    } else {
      this.createNewRoomObj();
    }

    let data = {
      subscriber_hash: currentuser?.email,
      tag: "Has Hosted"
    };
    updateTagToHasPlayed(data);
  }

  createNewRoomObj = () => {
    let play_again = this?.props?.socketReducer?.play_again;
    if (play_again === true) {
      return;
    }
    let gameObj = this.props.gameReducer;
    if (!JSON.parse(localStorage.getItem("webUrl"))) {
      createNewRoom(gameObj);
    }
    let dataObj = {
      gameName:
        gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
    };
    this.props.getGameData(dataObj);
    this.props.setPlayerCards([]);
  };

  componentDidUpdate(prevProps) {
    let prevroomObj = prevProps.gameReducer.roomObj;
    let currentroomObj = this.props.gameReducer.roomObj;
    if (currentroomObj && currentroomObj.active_game) {
      if (!this.state.usersChanged) {
        if (currentroomObj && currentroomObj.users && prevroomObj.users) {
          if (prevroomObj.users.length < currentroomObj.users.length) {
            this.setState({
              usersChanged: true
            });
          }
        }
      } else {
        if (this.state.usersChanged) {
          this.setState({
            usersChanged: false
          });
        }
      }

      if (
        prevroomObj.join_code !== currentroomObj.join_code &&
        this.state.link === ""
      ) {
      }
      let { gameObj } = this.props.paramsReducer;
      if (gameObj !== undefined) {
        if (Object.keys(gameObj).length > 0) {
          if (
            Object.keys(currentroomObj).length > 0 &&
            this.props.loaderDetails.isLoading &&
            !this.props.loaderDetails.changeTeam &&
            this.state.link !== "" &&
            !this.state.backBtnPress
          ) {
            this.props.setIsLoading(false);
          }
        }
      }
    }
  }

  reset = async () => {
    setIsLoading(true);
    this.props.setIsLoading(true);
    return new Promise(async (resolve) => {
      let roomData = this.props.gameReducer.roomObj;
      await this.props.emptyGameData({});
      await this.props.endGame(true);
      await this.props.setGameName(roomData.game_code);
      await this.createNewRoomObj();
    });
  };

  onBack = () => {
    localStorage.removeItem("webUrl");
    this.props.setLTparameters({});
    this.props.setViewerWebUrl(false);
    let roomData = this.props.gameReducer.roomObj;
    end_Game(roomData, this.props);
    this.props.toggleHowToPlay(false);
  };

  hexToRGB = (hex, alpha) => {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha !== "") {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  };

  componentWillUnmount() {
    this.removeListener();
    sessionStorage.removeItem("gameCode");
    // this.backListener();
  }
  toggleHowToPlay = () => {
    this.props.toggleHowToPlay(!this?.props?.socketReducer?.howToPlay);
  };
  toggle_how_to_play_modal = () => {
    this.setState({ howtoplay_modal_tot: !this.state.howtoplay_modal_tot });
  };
  on_start_vb_game = () => {
    this.setState({ vb_start_game: true });
  };

  render() {
    const { timer } = this.state;
    const { usersChanged } = this.state;
    let roomData = this.props.gameReducer.roomObj;
    let how_to_play = this?.props?.socketReducer?.howToPlay;
    let backgroundColor =
      this.props?.paramsReducer?.gameObj?.tabletop_placemat_rgb;
    let backgroundTrans =
      this.props?.paramsReducer?.gameObj?.tabletop_placemat_transparency;
    let how_to_play_title =
      this.props?.paramsReducer?.gameObj?.screens?.chpt?.how_to_play_title;

    let colors = "";
    let branchLink = this.props?.gameReducer?.roomObj.branch_url;
    if (backgroundColor) {
      colors = this.hexToRGB(backgroundColor, backgroundTrans);
    }
    const gameName = getGameName(roomData);
    const top_background_lt =
      this.props.gameReducer?.roomObj?.game_state?.background;
    const ltGlobalBackground =
      this.props.gameReducer?.roomObj?.game_state?.background;
    const status = this?.props?.gameReducer?.roomObj?.game_state?.status;
    const hasPlayers = roomData?.users?.length > 0;
    const ltGlobalStyles = {
      backgroundPosition: "center",
      backgroundSize: "auto",
      background: `url(${ltGlobalBackground}) no-repeat`
    };

    if (gameName && gameName === "DW20") {
      return (
        <>
          <Header dw20 gameTitle="Done With 2020 " />
          <div className="dw20Game">
            <Container fluid>
              <Row className="p-4 dw20-row">
                <Col sm={3} className="px-2">
                  <JoinNow
                    link={branchLink}
                    onBack={this.onBack}
                    isBackButton
                    type="DW20"
                    className="dw20-card barcode"
                    joinCodeTextClassName="scan-text"
                    dw20
                  />
                </Col>
                <Col sm={9} className="px-2">
                  <div
                    className="dw20-card h-100 teams"
                    style={{ background: colors }}
                  >
                    <DWPlayers usersChanged={usersChanged} />
                  </div>
                </Col>
              </Row>
            </Container>
            <div>{hasPlayers && <IceBreakers type="DW20" />}</div>
          </div>
        </>
      );
    } else if (gameName && gameName === "TOT") {
      return (
        <>
          <Header tot gameTitle="Tip of the Tongue" />
          <div className="tot-game">
            <Container fluid>
              <Row className="px-4 tot-row">
                <Col sm={3} className="px-2">
                  <JoinNow
                    link={branchLink}
                    onBack={this.onBack}
                    isBackButton
                    type="tot"
                    className="tot-card barcode"
                    joinCodeTextClassName="scan-text"
                  />
                </Col>
                <Col sm={9} className="px-2">
                  <div className="tot-card h-100">
                    <div className="tot-card-players">
                      <TotMain
                        usersChanged={usersChanged}
                        howtoplay_modal={this.state.howtoplay_modal_tot}
                        toggle_how_to_play_modal={this.toggle_how_to_play_modal}
                      />
                    </div>
                    <div
                      className={
                        this.state.howtoplay_modal_tot
                          ? "how_to_play_click"
                          : "how_to_play_main"
                      }
                    >
                      <img src={Host} className="host-image" alt="" />
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div>{hasPlayers && <IceBreakers type="tot" />}</div>
        </>
      );
    } else if (gameName && gameName === "VB") {
      return (
        <>
          <Header verboden gameTitle="Verboden" />

          <div className="verboden-game">
            <Container fluid>
              <Row className="verboden-row">
                <Col sm={3} className="pe-3 ps-2">
                  <AnimatePresence exitBeforeEnter>
                    <JoinNow
                      key="vb_join_now"
                      link={branchLink}
                      onBack={this.onBack}
                      isBackButton
                      type="verboden"
                      className="verboden-card barcode"
                      joinCodeTextClassName="scan-text"
                      VB
                      vb_start_game={this.state.vb_start_game}
                    />
                  </AnimatePresence>
                </Col>
                <Col sm={9} className="">
                  <AnimatePresence exitBeforeEnter>
                    <motion.div
                      key="vb_join_right"
                      variants={
                        !this.state.vb_start_game
                          ? slideHorizontalRightVariants
                          : slideHorizontalRightExitVariants
                      }
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      className="verboden-card h-100 teams sfsdf"
                    >
                      <Teams usersChanged={usersChanged} />
                      <Timer
                        timer={timer}
                        on_start_game={this.on_start_vb_game}
                      />
                    </motion.div>
                  </AnimatePresence>
                </Col>
              </Row>
            </Container>
            <div>{hasPlayers && <IceBreakers type="verboden" />}</div>
          </div>
        </>
      );
    } else if (gameName && (gameName === "GAH" || gameName === "GAHW")) {
      return (
        <>
          <div className="lobby GAH-game py-3">
            <Container fluid>
              <Row className="GAH-row">
                <Col lg={3} sm={3} className="mb-3 mb-md-4 mb-lg-0">
                  <JoinNow
                    paramsReducer={this.props.paramsReducer}
                    link={branchLink}
                    isBackButton
                    type="GAH"
                    gameName={gameName}
                    onBack={this.onBack}
                    className="GAH-card barcode"
                    GAH
                  />
                </Col>
                <Col lg={9} sm={9}>
                  <Player
                    onBack={this.onBack}
                    type="GAH"
                    {...this.props}
                    usersChanged={usersChanged}
                    className="GAH-card game-players"
                  />
                </Col>
              </Row>
            </Container>
            <div>{hasPlayers && <IceBreakers type="GAH" />}</div>
          </div>
        </>
      );
    } else if (gameName === "TW") {
      return (
        <>
          <TwHeader />

          <div className="lobby tw-lobby-main py-3">
            <Container fluid="xxl">
              <Row>
                <Col md={3} className="mb-3 mb-md-4 mb-lg-0 Tw-main">
                  <JoinNow
                    paramsReducer={this.props.paramsReducer}
                    type="TW"
                    link={branchLink}
                    onBack={this.onBack}
                    className="wt-card barcode"
                    TW
                  />
                </Col>
                <Col md={9}>
                  <Player
                    onBack={this.onBack}
                    {...this.props}
                    type="TW"
                    usersChanged={usersChanged}
                  />
                </Col>
              </Row>
            </Container>
            <div>{hasPlayers && <IceBreakers type="TW" />}</div>
          </div>
        </>
      );
    } else if (gameName && gameName === "OCH") {
      return (
        <>
          <div className="och-wrapper">
            <div className="OCHGame">
              <Container fluid>
                <Row className="p-4 OCH-row">
                  <Col sm={3} className="px-2">
                    <JoinNow
                      link={branchLink}
                      onBack={this.onBack}
                      isBackButton
                      type="OCH"
                      joinCodeTextClassName="scan-text"
                      className="OCH-card barcode"
                      OCH
                    />
                  </Col>
                  <Col sm={9} className="px-2">
                    <div
                      className="OCH-card h-100 teams"
                      style={{ background: colors }}
                    >
                      <OCHPlayer usersChanged={usersChanged} />
                    </div>
                  </Col>
                </Row>
              </Container>
              <div>{hasPlayers && <IceBreakers type="OCH" />}</div>
            </div>
          </div>
        </>
      );
    } else if (gameName && (gameName === "CHPT" || gameName === "CHPTW")) {
      return (
        <>
          <Header
            CHPT
            gameTitle="Charty Party "
            toggleHowToPlay={this.toggleHowToPlay}
            how_to_play={how_to_play}
            how_to_play_title={how_to_play_title}
          />
          <div className="CHPTGame">
            <Container fluid>
              <Row className="p-4 p-md-0 CHPT-row">
                <Col sm={3} className="px-2">
                  <JoinNow
                    link={branchLink}
                    onBack={this.onBack}
                    isBackButton
                    type="CHPT"
                    className="CHPT-card barcode"
                    joinCodeTextClassName="scan-text"
                    CHPT
                  />
                </Col>
                <Col sm={9} className="px-2">
                  <div
                    className="htplay h-100 teams"
                    style={{ background: colors }}
                  >
                    <ChartyPartyLobby
                      how_to_play={how_to_play}
                      usersChanged={this.usersChanged}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
            <div>{hasPlayers && <IceBreakers type="CHPT" />}</div>
          </div>
        </>
      );
    } else if (gameName && gameName === "CT") {
      return (
        <>
          <div className="CT-wrapper">
            <Header CT gameTitle="" />
            <div className="CTGame">
              <Container fluid>
                <Row className="pl-4 pr-4 CT-row">
                  <Col sm={3}>
                    <JoinNow
                      link={branchLink}
                      onBack={this.onBack}
                      type="CT"
                      joinCodeTextClassName="scan-text"
                      className="CT-card barcode"
                      CT
                    />
                  </Col>
                  <Col sm={9}>
                    <div
                      className="CT-card h-100 teams"
                      style={{ background: colors }}
                    >
                      <CTPlayer usersChanged={usersChanged} />
                    </div>
                  </Col>
                </Row>
              </Container>
              <div>{hasPlayers && <IceBreakers type="CT" />}</div>
            </div>
          </div>
        </>
      );
    } else if (gameName && gameName === "SK") {
      return (
        <>
          <Header slideKick gameTitle="slideKick" />
          <div className="slideKick">
            <Container fluid>
              <Row className="p-4 slideKick-row">
                <Col sm={3} className="px-2">
                  <JoinNow
                    link={branchLink}
                    type="slideKick"
                    className="slideKick-card barcode"
                    joinCodeTextClassName="scan-text"
                    slideKick
                  />
                </Col>
                <Col sm={9} className="sk-users-height px-2">
                  <div className="slideKick-card h-100">
                    <SlideKick
                      onBack={this.onBack}
                      usersChanged={usersChanged}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      );
    } else if (gameName && gameName === "FLUS") {
      return (
        <>
          <Fluster
            usersChanged={usersChanged}
            onBack={this.onBack}
            branchLink={branchLink}
          />
          {hasPlayers && <IceBreakers type="FLUS" />}
        </>
      );
    } else if (gameName && gameName === "BNG") {
      return (
        <>
          <Header BNG gameTitle="Bingo" />
          <div className="bingo_game">
            <Bingo
              usersChanged={usersChanged}
              onBack={this.onBack}
              branchLink={branchLink}
            />
          </div>
        </>
      );
    } else if (
      gameName &&
      (gameName === "LT" ||
        gameName === "LTS" ||
        gameName === "WELL" ||
        gameName === "CC" ||
        gameName === "TOTO" ||
        gameName === "TTL")
    ) {
      return (
        <>
          {gameName !== "WELL" && <Header SBS gameTitle="LT" />}
          <div
            className={cx("sbs-game-main ", {
              Global: top_background_lt,
              well: gameName === "WELL"
            })}
            style={ltGlobalBackground ? { ...ltGlobalStyles } : {}}
          >
            <SmallBitesLobby
              usersChanged={usersChanged}
              onBack={this.onBack}
              branchLink={branchLink}
            />
          </div>
        </>
      );
    } else return <div className="lobby py-3"></div>;
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
  webUrlReducer: state.webUrlReducer,
  socketReducer: state.socketReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    getGameData: (data) => dispatch(paramsAction.getGameData(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    setPlayerCards: (data) => dispatch(gameAction.setPlayerCards(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    setLTparameters: (data) => dispatch(socketAction.setLTparameters(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
    setViewerWebUrl: (data) => dispatch(webUrlAction.setViewerWebUrl(data)),
    toggleHowToPlay: (data) => dispatch(socketAction.toggleHowToPlay(data))
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LobbyScreen);
